import { render } from "./Trip.vue?vue&type=template&id=7c509a0d"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"
script.render = render

export default script